<template>
  <b-col>
    <b-row v-for="(filter, indexFilter) in column.filters" :key="'row-' + indexFilter">
      <b-col v-if="filter.name && (!filter.showIf || filter.showIf() === true)">
        <quick-filters-fields :filter="filter" :quick-filters="quickFilters" />
      </b-col>
      <quick-filters-column
        :quick-filters="quickFilters"
        :column="subColumn"
        v-for="(subColumn, indexSubColumn) in filter.columns"
        :key="'subcolumn-' + indexSubColumn"
        :class="subColumn.class"
        v-if="filter.columns"
      />
    </b-row>
  </b-col>
</template>

<script>
import QuickFiltersColumn from './QuickFiltersColumn'
import QuickFiltersFields from './QuickFiltersFields'

export default {
  name: 'QuickFiltersColumn',
  components: {
    QuickFiltersColumn,
    QuickFiltersFields
  },
  props: {
    column: {
      type: Object,
      required: true
    },
    quickFilters: {
      type: Object,
      required: true
    }
  }
}
</script>
